import React, {useEffect, useState} from 'react';
import {Chart} from 'primereact/chart';

function getNrSongsPerMemberFromPlaylist(playlist) {
    let indexOfOther = 8
    let labels = ['BTS', 'RM', 'JIN', 'SUGA', 'j-hope', 'Jimin', 'V', 'Jung Kook', 'Other', 'Agust D']
    let counts = new Array(labels.length).fill(0);
    for (let i = 0; i < playlist.length; i++) {
        let artistsong = playlist[i].nameconcat;
        let notfound = true;
        let j = 0;
        while (notfound && j < labels.length) {
            if (artistsong.startsWith(labels[j])) {
                notfound = false;
                counts[j] = counts[j] + 1
            }
            j = j + 1;
        }
        if (notfound) {
            counts[indexOfOther] = counts[indexOfOther] + 1
        }
    }
    labels.push("Other")
    labels[3] = "SUGA / Agust D"
    counts[3] = counts[3] + counts[9]
    return {"counts": counts.slice(0, 9), "labels": labels.slice(0, 9)};
}

export default function SongDistributionChart({playlist}) {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        const nrSongsPerMember = getNrSongsPerMemberFromPlaylist(playlist);

        const data = {
            labels: nrSongsPerMember["labels"],
            datasets: [
                {
                    type: 'bar',
                    label: 'Number of Plays',
                    backgroundColor: documentStyle.getPropertyValue('--primary-500'),
                    data: nrSongsPerMember["counts"]
                }
            ]
        };
        const options = {
            indexAxis: 'y',
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    beginAtZero: true,
                    stacked: true,
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };

        setChartData(data);
        setChartOptions(options);
    }, [playlist]);

    return (
        <div className="card">
            <Chart type="bar" data={chartData} options={chartOptions} />
        </div>
    )
}
